import {mapState} from 'vuex';
// import KsGroupSelect from 'ksc-vue-ui2/src/components/KsSelect/index.vue';
import KsServerIp from 'ksc-vue-ui2/src/components/KsServerIp/index.vue';
import EventHub from 'ksc-vue-ui2/src/services/EventHub';
import KsDialog from 'ksc-vue-ui2/src/components/dialog/index.vue';
import * as step1Const from '../../store/create/step1/constants';
import * as step3Const from '../../store/create/step3/constants';
import commonAlert from '../../services/common/alert';
import Message from 'kpc/components/message';
import Tooltip from 'kpc/components/tooltip';
import Button, {ButtonGroup} from 'kpc/components/button';
import Vue from 'vue';
import {Select, Option} from 'kpc/components/select';
import Checkbox from 'kpc/components/checkbox';
import { DedicatedList } from '../../store/common/constants';
import Table, { TableColumn }from 'kpc/components/table';
import Input from 'kpc/components/input';
import Icon from 'kpc/components/icon';
import Card from 'kpc/components/card';
import _ from 'lodash';


export default {
    name: 'Create-Step3',
    components: {
        // KsGroupSelect,
        KsServerIp,
        EventHub,
        KsDialog,
        Button, 
        ButtonGroup,
        Select,
        Option,
        Checkbox,
        Tooltip,
        Table,
        TableColumn,
        Input,
        Icon,
        Card,
    },
    props: {
        regionKey: {
            type: String,
            default: ''
        },
        azCode: {
            type: String,
            default: ''
        },
        azCodeList:{
            type: Array,
            default: () => [],
            required: false
        },
        // hasAz: {
        //     type: Boolean,
        //     default: false
        // },
        azName: {
            type: String,
            default: ''
        },
        kecCount: {
            type: Number,
            default: 20
        },
        DstartTempData: {
            type: Object,
            default: () => {}
        },
        DtheSameConfigData: {
            type: Object,
            default: () => {}
        },
        DsourcePage: {
            type: String,
            default: ''
        },
        PackageCode:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            fixIpMode: 'auto',
            isShow: false,
            vpcList: [],
            vpcObj: '',
            subnetList: [],
            subnetObj: '',
            serverIp: '',
            ipList: [],
            dhcpFrom: '',
            dhcpTo: '',
            securityGroupList: [],
            securityGroupObj: [],
            isCreateVpc: false,
            ipListLength: 0,
            ipMsg: '',
            legalIp: true,
            ipCount: 0,
            ipTip: '',
            fetchAdrListLoading: false,
            // _fetchVpcDataLoading: false,
            showAssignIp: true,
            isSupportIPV6: false,
            ipv6TypeCodes: [], //支持IPV6的机型数据
            vpcValue:'',
            subnetValue:'',
            securityValue:[],
            IsDistributeIpv6:false,
            startTemplateId:'',
            startTempData:'',
            theSameConfigData: '',
            addSecnicNum: -1,
            hasSecnicNum: -1,
            secNicList: [],
            hasMoreSubnet: true,
            // isSupportSecnic: false,
            // disabledSubnetIdList: [],
            markCount:0,
            showNoSubnetTip:false,
            GroupsQuotaMaxData:1,
            sgKeywords:'',
        };
    },
    created() {
        this.SKIP = _.get(window, 'KSC_SECNET_CONSOLE.BASE_HOST', 'console.ksyun.com');
        // if (this.SKIP != 'console.ksyun.com') {
        //     window.location.href = '/';
        // }

        // if (this.$route.name == "CreateView") { //创建公有云支持辅网卡
        //     this.isSupportSecnic = true;
        // }

        EventHub.$on('on-createVpcResult-close', () => {
            this.$set(this, 'isCreateVpc', false);
        });
        EventHub.$on('on-createVpcResult-ok', () => {
            this.$set(this, 'isCreateVpc', false);
            // this._fetchVpcData();
            this.getVpcData()
        });
    },
    computed: {
        ...mapState({
            allVpcSet: state => state.__pbc__.step3.allVpcSet,
            adrListSet: state => state.__pbc__.step3.adrListSet,
            AvailableIpAddress: state => state.__pbc__.step3.AvailableIpAddress,
            NotAvailableIpAddress: state => state.__pbc__.step3.NotAvailableIpAddress,
            SubnetSet: state => state.__pbc__.step3.SubnetSet,
            common: state => state.__pbc__.common,
        }),
        isRefresh(){
            return {
                azCode: this.azCode,
                azCodeList: this.azCodeList
            }
        }
    },
    methods: {
        sText(){
            const valuesLength = this.securityValue.length;
            const dataLength = this.securityGroupList.length;
            return valuesLength && dataLength ? this.$trans(`已选择{0}项 / 共{1}项`,valuesLength,dataLength) : null;
        },
        pText(pItem){
            const valuesLength = pItem.securityValue.length;
            const dataLength = pItem.securityGroupList.length;
            return valuesLength && dataLength ? this.$trans(`已选择{0}项 / 共{1}项`,valuesLength,dataLength) : null;
        },
        filterSGList(){
            const data = this.securityGroupList
            const keywords = this.sgKeywords
            if(!keywords){
                return data
            }
            return data.filter(item => {
                return item.title.includes(keywords)
            })
        },
        pFilterSGList(pItem){
            const data = pItem.securityGroupList
            const keywords = pItem.sgKeywords
            if(!keywords){
                return data
            }
            return data.filter(item => {
                return item.title.includes(keywords)
            })
        },
        checkedKeys(){
            return _.map(this.securityValue, item => item)
        },
        confirm(){
            const data = this.$refs.table.getCheckedData()
            if(data.length > this.GroupsQuotaMaxData){
                Message.error(this.$trans(`安全组数量已达到上限`))
                return
            } 
            this.securityValue = data.map(item => {
                return item.value
            })

            this.hide() 
            
        },
        pCheckedKeys(pItem){
            return _.map(pItem.securityValue, item => item)
        },
        pConfirm(pItem,key){
            const pTableList = this.$refs.pTable.filter(item => {
                return item != null && !item.destroyed
            }) || []
            const data = pTableList[key].getCheckedData()
            if(data.length > this.GroupsQuotaMaxData){
                Message.error(this.$trans(`安全组数量已达到上限`))
                return
            } 
            pItem.securityValue = data.map(item => {
                return item.value
            })
            var _securityGroupList = this.getSecurityGroupList(pItem.vpcObj)
            pItem.securityGroupObj = _.map(pItem.securityValue,item => {
                return _.filter(_securityGroupList,groupItem => {
                    return item === groupItem.value
                })[0]
            })
            this.pHide(pItem,key) 
        },
        hide() {
            this.sgKeywords = ''
            this.$refs.securitygroup.hide()
        },
        pHide(pItem,key){
            pItem.sgKeywords = ''
            this.$refs.pSecuritygroup[key].hide()
        },
        //获取VPC相关
        getVpcData(){
            var params = {
                azCode: this.azCode,
                Region: this.regionKey,
                subnetType: 'Normal',
            }

            //查询套餐动态网卡个数配额
            let _parent = this.$parent;
            let QueryProductNetworkInterfaceQuota = this.$store.dispatch(step3Const.QueryProductNetworkInterfaceQuota, {
                params: {
                    ProductTypeId: _.get(_parent, 'step1Data.kecType', '') || _.get(_parent, 'kvmData.productType', ''),
                    PackageCode: this.PackageCode,
                    Region: this.regionKey
                }
            });
            //一定要删除的代码，只是本地接口代理有问题先写死而已！！！！！
            // QueryProductNetworkInterfaceQuota = new Promise(resolve => resolve({Return:true,Quota:2}))
            
            let AllVpcInfo = this.$store.dispatch(step3Const.AllVpcInfo, params);
            let DescribeSecurityGroupsQuota = this.$store.dispatch(step3Const.DescribeSecurityGroupsQuota,{
                params: {
                    Region: this.regionKey
                }
            });

            return Promise.all([QueryProductNetworkInterfaceQuota, AllVpcInfo,DescribeSecurityGroupsQuota]).then(([data, __data,GroupsQuotaData]) => {
                // this.hasSecnicNum = data.count;
                // 获取可以绑定的安全组最大限额
                this.GroupsQuotaMaxData = GroupsQuotaData.MAX

                let hasSecnicNum = 0;
                if (data.Return) {
                    hasSecnicNum = _.toNumber(data.Quota).toFixed(0) - 1; //此Quota值需要减去主网卡的数量
                }
                
                if (hasSecnicNum - this.secNicList.length < 0) {
                    this.secNicList.splice(hasSecnicNum, this.secNicList.length - hasSecnicNum);
                }
                hasSecnicNum = hasSecnicNum - this.secNicList.length;
                this.addSecnicNum = this.secNicList.length - 1;
                this.hasSecnicNum = hasSecnicNum ? hasSecnicNum : 0;

                this.hasMoreSubnet = true;
                var allVpcSet = this.allVpcSet;
                var vpcList = _.map(allVpcSet.VpcSet, (item) => {
                    if (item.ProvidedIpv6CidrBlock) {
                        item.title = item.VpcName + " (" + item.CidrBlock + "，" + _.get(item, 'Ipv6CidrBlockAssociationSet[0].Ipv6CidrBlock', '') + " )";
                    } else {
                        item.title = item.VpcName + " (" + item.CidrBlock + ")";
                    }
                    item.value = item.VpcId;
                    return item;
                });
                this.vpcList = vpcList;

                // debugger;
                if (!_.find(vpcList, (item) => {
                        return item.value == this.vpcObj.value
                    })) {
                    if (this.DsourcePage == 'createTemplate' || this.DsourcePage == 'modifyTemplate') {
                        this.showAssignIp = false;
                    }
                    if ((this.DsourcePage == 'modifyTemplate' || this.DsourcePage == 'buyTemplate') && Object.keys(this.DstartTempData).length) {
                        //通过VpcId查找VPC列表是否有对应的选项
                        this.vpcObj = _.find(vpcList, (subItem) => {
                            return subItem.VpcId == _.get(this.DstartTempData, 'subnetInfo.VpcId', '');
                        }) || {};
                        if (!Object.keys(this.vpcObj).length) {
                            // Message.error('所选关联VPC已被删除，请重新选择！');
                            this.vpcObj = vpcList[0] || {};
                        }
                        // this.vpcValue = this.DstartTempData.securityGroupInfo.VpcId
                        this.vpcValue = this.vpcObj.VpcId
                        let NetworkInterfaceSet = _.get(this.DstartTempData, 'NetworkInterfaceSet', []);
                        if (NetworkInterfaceSet.length) {
                            _.forEach(NetworkInterfaceSet, (item) => {
                                // this._addSecnicNum(item);
                                this.fetchSecNicIpList('startTempData', item);
                            });
                        }
                    } else if (this.DsourcePage == 'createTheSameConfig' && Object.keys(this.DtheSameConfigData).length) {
                        //通过VpcId查找VPC列表是否有对应的选项
                        let primaryNetworkInfo = _.find(this.DtheSameConfigData.networkInfo, (item) => {
                            return item.NetworkInterfaceType == "primary";
                        });
                        this.vpcObj = _.find(vpcList, (subItem) => {
                            return subItem.VpcId == _.get(primaryNetworkInfo, 'VpcId', '');
                        }) || {};
                        if (!Object.keys(this.vpcObj).length) {
                            // Message.error('所选关联VPC已被删除，请重新选择！');
                            this.vpcObj = vpcList[0] || {};
                        }
                        this.vpcValue = this.vpcObj.VpcId
                        let extensionNetworkInfo = _.filter(this.DtheSameConfigData.networkInfo, (item) => {
                            return item.NetworkInterfaceType == "extension";
                        });
                        if (extensionNetworkInfo.length) {
                            _.forEach(extensionNetworkInfo, (item) => {
                                // this._addSecnicNum(item);
                                this.fetchSecNicIpList('createTheSameConfig', item);
                            });
                        }
                        
                    } else {
                        this.vpcObj = vpcList[0] || {};
                    }
                } else {
                    this._filterSubNet();
                    this._filterSecurityGroup();
                }
            });
        },
        templateGet(data, string, defaultValue) {
            return _.get(data, string, defaultValue);
        },
        //子网数据过滤
        getsubnetList(vpcObj,isSecSubnet){
            let subnetList = [];
            let _parent = this.$parent;
            let step1Data = {};
            let soldoutList = [];
            let systemDiskType = '';
            let ebsList = [];
            let volumeType = [];
            let allDiskType = [];
            if (_parent.step1Data) {
                step1Data = _parent.step1Data;
                soldoutList = _.get(step1Data, 'mock.soldoutList', []);
                systemDiskType = _.get(step1Data, 'kvm.systemDiskType', '');
                ebsList = _.get(step1Data, 'ebsList', []);
                if (ebsList.length) {
                    volumeType = _.map(ebsList, 'volumeType');
                }
                allDiskType = [systemDiskType].concat(volumeType);
            }

            // subnetList = _.filter(this.allVpcSet.SubnetSet, (item) => {
            //     return item.VpcId == vpcObj.VpcId;
            // });

            let SubnetSet = this.allVpcSet.SubnetSet;
            if (SubnetSet && SubnetSet.length) {
                _.forEach(SubnetSet, (item) => {
                    item.value = item.SubnetId;
                });
            }

            subnetList = _.filter(SubnetSet, (item) => {
                return item.VpcId == vpcObj.VpcId;
            });
            
            if(!this.azCode){
                subnetList = subnetList.filter(item =>{
                    if(!isSecSubnet){
                        return _.find(this.azCodeList,o => o === item.AvailabilityZoneName)
                    } else {
                        return item.AvailabilityZoneName === this.subnetObj.AvailabilityZoneName
                    }
                });
            }
            subnetList = _.filter(subnetList, (item) => {
                if (item.ProvidedIpv6CidrBlock) {
                    item.title = item.SubnetName + " (" + item.CidrBlock + "，" + _.get(item, 'Ipv6CidrBlockAssociationSet[0].Ipv6CidrBlock', '') + " )";
                } else {
                    item.title = item.SubnetName + " (" + item.CidrBlock + ")";
                }
                item.value = item.SubnetId;

                //当前可用区下云盘已售罄, 请选择其他可用区下子网
                if (_parent.step1Data && soldoutList.length) {
                    _.forEach(soldoutList, sub => {
                        if (item.AvailabilityZoneName == sub.AvailabilityZone && _.includes(allDiskType, sub.ProductCode)) {
                            item.disabled = true;
                            item.tipInfo = this.$trans(`{0}下{1}云盘已售罄, 请选择其他可用区下子网。`, this.common.azMap[item.AvailabilityZoneName], sub.ProductCode);
                            return
                        }
                    });
                }

                return item.title;
            });
            return subnetList
        },
        //过滤安全组数据
        getSecurityGroupList(vpcObj){
            var _securityGroupList = _.filter(this.allVpcSet.SecurityGroupSet, (item) => {
                return (item.VpcId == vpcObj.VpcId || item.SecurityGroupType === 'global');
            });

            _securityGroupList = _.map(_securityGroupList, (item) => {
                item.title = item.SecurityGroupName;
                item.value = item.SecurityGroupId;
                item.type = item.SecurityGroupType;
                return item;
            });
            return _securityGroupList
        },
        //关联子网
        _filterSubNet: function () {
            var res = this.getsubnetList(this.vpcObj,false)

            this.subnetList = res;
            if (!_.find(res, (item) => {
                return item.value == _.get(this.subnetObj, 'value', '');
            })) {
                if ((this.DsourcePage == 'modifyTemplate' || this.DsourcePage == 'buyTemplate') && Object.keys(this.DstartTempData).length) {
                    //通过VpcId查找VPC列表是否有对应的选项
                    if (!res) {
                        this.subnetObj = {};
                    }
                    this.subnetObj = _.find(res, (subItem) => {
                        return subItem.SubnetId == _.get(this.DstartTempData, 'subnetInfo.SubnetId');
                    }) || {};
                    if (!Object.keys(this.subnetObj).length) {
                        // Message.error('所选关联子网已被删除，请重新选择！');
                        this.subnetObj = res && res[0] || {};
                    }
                    this.subnetValue = this.DstartTempData.subnetInfo.SubnetId
                    this.IsDistributeIpv6 = this.DstartTempData.IsDistributeIpv6
                } else if (this.DsourcePage == 'createTheSameConfig' && Object.keys(this.DtheSameConfigData).length) {
                    if (!res) {
                        this.subnetObj = {};
                    }
                    this.subnetObj = _.find(res, (subItem) => {
                        return subItem.SubnetId == _.get(this.DtheSameConfigData, 'SubnetId');
                    }) || {};
                    // if (!Object.keys(this.subnetObj).length) {
                    //     this.subnetObj = res && res[0] || {};
                    // }
                    // this.subnetValue = this.DtheSameConfigData.SubnetId

                    if (_.isEmpty(this.subnetObj)) {
                        this.subnetObj = res && res[0] || {};
                        this.subnetValue = _.get(this.subnetObj, 'SubnetId', '');
                    } else {
                        this.subnetValue = this.DtheSameConfigData.SubnetId
                    }
                    this.IsDistributeIpv6 = this.DtheSameConfigData.IsDistributeIpv6
                } else {
                    this.subnetObj = res && res[0] || {};
                }
            }

            return this._fetchAdrList();
        },
        _addSecnicNum(vifsData, secNicIpList) {
            if(!this.subnetList.length && !this.azCode){
                this.showNoSubnetTip = true
            } else {
                this.showNoSubnetTip = false
            }
            if((this.hasSecnicNum > 0 || this.DsourcePage === 'createTheSameConfig' && this.hasSecnicNum >=0) && this.hasMoreSubnet){
                if(!(this.DsourcePage === 'createTheSameConfig' && this.hasSecnicNum === 0)){
                    this.hasSecnicNum--; 
                }
                this.addSecnicNum++;
                this.addNetWorkData('add', vifsData, secNicIpList);
            }
        },
        fetchSecNicIpList(origin, list, idx) {
            var subnetObj = {};
            var secNicList = [];

            if (origin == 'startTempData' || origin == 'createTheSameConfig') { //来源启动模板 或 创建相同配置
                subnetObj = list;
            } else {
                subnetObj = list[idx].subnetObj || '';
                secNicList = list;
            }

            if (!subnetObj || !subnetObj.SubnetId) {
                if (origin == 'startTempData' || origin == 'createTheSameConfig') {
                    this._addSecnicNum(list, []);
                } else {
                    secNicList[idx].ipList = [];
                    this.secNicList = secNicList;
                }
                return
            };

            let AdrCount = this.$store.dispatch(step3Const.AdrCount, {
                subnetId: subnetObj.SubnetId,
                Region: this.regionKey,
            });

            // if (self.kecCount == 1) {
                //查询网络预留IP
                let DescribePrivateIpAddressAttributes = this.$store.dispatch(step3Const.DescribePrivateIpAddressAttributes, {
                    params: {
                        'Region': this.regionKey,
                        AvailabilityZone: this.azCode,
                        Status: 'retain',
                        SubnetId: subnetObj.SubnetId
                    }
                });

                //查询已占用IP
                let AllocatedAdrList = this.$store.dispatch(step3Const.AllocatedAdrList, {
                    subnetId: subnetObj.SubnetId,
                    Region: this.regionKey,
                });

                return Promise.all([AllocatedAdrList, DescribePrivateIpAddressAttributes, AdrCount]).then(([data, __data, adrCount]) => {
                    if (data.code !== undefined && data.code != 200) {
                        Message.error(data.msg);
                        return;
                    }
                    var ipList = this.NotAvailableIpAddress || [];
                    var privateIp = [];
                    if (__data && __data.PrivateIpAddressAttributeSet.length) {
                        privateIp = _.map(__data.PrivateIpAddressAttributeSet, 'PrivateIpAddress');
                    }
                    var ipListLength = _.get(adrCount, 'count', 0);
                    if (origin == 'startTempData' || origin == 'createTheSameConfig') {
                        let secNicIpList = ipList.concat(privateIp);
                        list.ipListLength = ipListLength;
                        this._addSecnicNum(list, secNicIpList);
                    } else {
                        secNicList[idx].ipList = ipList.concat(privateIp);
                        secNicList[idx].ipListLength = ipListLength;
                        this.secNicList = secNicList;
                    }

                }, (e) => {
                    Message.error(e.msg || e);
                });
            // }
        },
        addNetWorkData(params, vifsData, secNicIpList) {
            if (params != 'add') {
                return;
            }
            var self = this;
            var idx = self.addSecnicNum;
            var list = _.cloneDeep(self.secNicList);
            list.push({
                key: 'k-' + idx,
                name: 'secnic-' + idx,
            });

            if ((this.DsourcePage == 'modifyTemplate' || this.DsourcePage == 'buyTemplate' || this.DsourcePage == 'createTheSameConfig') && (vifsData.SecurityGroupId || vifsData.SecurityGroupIds)) {
                var vpcObj = {};
                var vpcValue = '';
                var subnetList = [];
                var subnetObj = {};
                var subnetValue = '';
                var securityGroupList = [];
                var securityGroupObj = [];
                var securityValue = [];
                var fixIpMode = 'auto';
                var serverIp = '';

                if (this.DsourcePage == 'modifyTemplate' || this.DsourcePage == 'buyTemplate') {
                    vpcValue = vifsData.subnetInfo.VpcId;
                    subnetValue = vifsData.subnetInfo.SubnetId;
                    // fixIpMode = vifsData.subnetInfo.GatewayIp ? 'manual' : 'auto';
                    // fixIpMode = 'auto';
                    serverIp = vifsData.subnetInfo.GatewayIp;
                    // serverIp = '';
                } else if (this.DsourcePage == 'createTheSameConfig') {
                    vpcValue = vifsData.VpcId;
                    subnetValue = vifsData.SubnetId;
                    // fixIpMode = vifsData.PrivateIpAddress ? 'manual' : 'auto';
                    // fixIpMode = 'auto';
                    serverIp = vifsData.PrivateIpAddress;
                    // serverIp = '';
                }

                // securityValue = vifsData.SecurityGroupId;

                vpcObj = _.find(self.vpcList, (item) => {
                    return item.VpcId == vpcValue;
                });
                subnetList = this.getsubnetList(vpcObj,true)

                subnetObj = subnetList[0];

                var _securityGroupList = this.getSecurityGroupList(vpcObj)

                // securityGroupObj = _securityGroupList.length ? [_securityGroupList[0]] : [];

                if (this.DsourcePage == 'modifyTemplate' || this.DsourcePage == 'buyTemplate') {
                    if(vifsData.SecurityGroupId){
                        securityGroupObj = [_.find( _securityGroupList,groupItem => {
                            return groupItem.SecurityGroupId == vifsData.SecurityGroupId
                        })]
                        securityValue = [vifsData.SecurityGroupId]
                    } else {
                        securityGroupObj = _.map(vifsData.securityGroupInfos,item => {
                             if(_.find(_securityGroupList,groupItem => {
                                return groupItem.SecurityGroupId == item.SecurityGroupId
                            })){
                                return item.securityGroupInfo
                            }
                        }) || []
                        securityValue = _.map(securityGroupObj,item => item.SecurityGroupId)
                    }
                } else if (this.DsourcePage == 'createTheSameConfig') {
                    securityGroupObj = _securityGroupList.length ? _.filter(_securityGroupList,groupItem => {
                        return _.find(vifsData.SecurityGroupSet,item => {
                            return groupItem.SecurityGroupId === item.SecurityGroupId
                        })
                    }) : []
                    securityValue = _.map(securityGroupObj,item => item.SecurityGroupId)
                }
                

                securityGroupList = _securityGroupList.length ? _securityGroupList : [];

                list[idx].fixIpMode = fixIpMode;
                list[idx].oldFixIpMode = fixIpMode;
                list[idx].serverIp = serverIp;
                list[idx].ipMsg = '';
                list[idx].ipList = secNicIpList || [];
                list[idx].dhcpFrom = subnetObj.DhcpIpFrom;
                list[idx].dhcpTo = subnetObj.DhcpIpTo;
                list[idx].IsDistributeIpv6 = false;
                list[idx].isSupportIPV6 = false;
                list[idx].vpcObj = vpcObj || {};
                list[idx].vpcValue = vpcValue || '';
                list[idx].subnetList = subnetList;
                list[idx].subnetObj = subnetObj || {};
                list[idx].subnetValue = subnetValue || '';
                list[idx].securityGroupList = securityGroupList || [];
                list[idx].securityGroupObj = securityGroupObj || [];
                list[idx].securityValue = securityValue || [];
                list[idx].sgKeywords = ''
                this.secNicList = list;
            } else {
                var vpcObj = self.vpcList[0];
                let _subnetList = []
                _subnetList = this.getsubnetList(vpcObj,true)

                var _securityGroupList = this.getSecurityGroupList(vpcObj)
                let secList = _.filter(_securityGroupList, item => item.UserTag === 'console');

                var fixIpMode = 'auto';

                list[idx].subnetList = _subnetList;
                list[idx].fixIpMode = fixIpMode;
                list[idx].oldFixIpMode = fixIpMode;
                list[idx].serverIp = '';
                list[idx].ipMsg = '';
                list[idx].dhcpFrom = _subnetList.length ? _subnetList[0].DhcpIpFrom : '';
                list[idx].dhcpTo = _subnetList.length ? _subnetList[0].DhcpIpTo : '';
                list[idx].IsDistributeIpv6 = false;
                list[idx].isSupportIPV6 = false;
                list[idx].vpcObj = vpcObj ? vpcObj : {};
                list[idx].vpcValue = vpcObj ? vpcObj.value : '';
                list[idx].subnetObj = _subnetList.length ? _subnetList[0] : {};
                list[idx].subnetValue = _subnetList.length ? _subnetList[0].value : '';
                list[idx].securityValue = secList.length ? [secList[0].value] : [];
                list[idx].securityGroupObj = secList.length ? [secList[0]] : [];
                list[idx].securityGroupList = _securityGroupList.length ? _securityGroupList : [];
                list[idx].sgKeywords = ''
                this.fetchSecNicIpList('add', list, idx);
            }
        },
        _removeSecnicNum(key) {
            this.secNicList.splice(key, 1);
            this.hasSecnicNum++;
            this.addSecnicNum--;
        },
        async updateVpcData(){
            await this.getVpcData()
            this.updataSecNicList(this.secNicList, true)
        },
        updataSecNicList(data, isChange) {
            _.forEach(data, (p, idx) => {
                if (p.vpcValue || isChange) {
                    if (_.get(p, 'vpcObj.VpcId', '') != p.vpcValue || _.get(p, 'subnetObj.SubnetId', '') != p.subnetValue || p.oldFixIpMode != p.fixIpMode || isChange) {
                        
                        let vpcObj = _.filter(this.vpcList, (item) => {
                            return item.value == p.vpcValue;
                        })[0];

                        if(_.isEmpty(vpcObj)){
                            vpcObj = this.vpcList[0] || {}
                        }

                        data[idx].vpcObj = vpcObj;
                        data[idx].vpcValue = vpcObj.value;

                        let subnetList = []
                        subnetList = this.getsubnetList(vpcObj, true)

                        var _securityGroupList = this.getSecurityGroupList(vpcObj)

                        data[idx].subnetList = subnetList;

                        const subnetObj = _.find(subnetList, (item) => {
                            return item.SubnetId == p.subnetValue;
                        }) || {};

                        if(_.keys(subnetObj).length){
                            data[idx].subnetObj = subnetObj
                            data[idx].subnetValue = subnetObj.value;
                        } else {
                            data[idx].subnetObj = subnetList.length ? subnetList[0] : {};
                            data[idx].subnetValue = subnetList.length ? subnetList[0].value : '';
                        }

                        const sgList = _.filter(_securityGroupList, item => {
                            return _.includes(p.securityValue, item.value)
                        })
                        let secList = _.filter(_securityGroupList, item => item.UserTag === 'console');

                        if(sgList?.length){
                            data[idx].securityValue = _.map(sgList, item => item.value)
                            data[idx].securityGroupObj = sgList;
                        } else {
                            data[idx].securityValue = secList.length ? [secList[0].value] : [];
                            data[idx].securityGroupObj = secList.length ? [secList[0]] : [];
                        }

                        
                        data[idx].securityGroupList = _securityGroupList.length ? _securityGroupList : [];
                        data[idx].dhcpFrom = data[idx].subnetObj.DhcpIpFrom;
                        data[idx].dhcpTo = data[idx].subnetObj.DhcpIpTo;
                        data[idx].sgKeywords = ''
                        if (this.DsourcePage == 'createTemplate' || this.DsourcePage == 'modifyTemplate') {
                            data[idx].oldFixIpMode = 'auto';
                        } else {
                            if (p.oldFixIpMode != p.fixIpMode) {
                                data[idx].oldFixIpMode = p.fixIpMode;
                            }
                        }
                        
                        data[idx].serverIp = '';
                        data[idx].ipMsg = '';
                        // this.secNicList = data;
                        this.fetchSecNicIpList('add', data, idx);
                    }

                }
            });
        },
        isSupportIPV6Code(data) {
            if (data) {
                return _.indexOf(this.ipv6TypeCodes, _.toNumber(data)) !== -1;
                // console.log(data, this.ipv6TypeCodes, 3)
                // return _.indexOf(this.ipv6TypeCodes, data) !== -1;
            } else {
                return false;
            }
        },
        ValidateIpv6Support() {
            //获取支持IPV6的机型ProductTypeId的数据
            return this.$store.dispatch(step3Const.ValidateIpv6Support, {
                params: {
                    Region: this.regionKey,
                }
            }).then((res) => {
                // console.log(res.data, 123)
                if (res && res.data) {
                    let ipv6TypeCodes = [];
                    _.forEach(res.data, item => {
                        if (!item.regions) {
                            ipv6TypeCodes.push(item.productTypeId * 1);
                        } else if (item.regions.indexOf(this.regionKey) !== -1) {
                            ipv6TypeCodes.push(item.productTypeId * 1);
                        }
                    });
                    this.ipv6TypeCodes = ipv6TypeCodes;
                    // this.ipv6TypeCodes = res.data;
                }
            }).catch(e => {
                commonAlert.send(e, 'kecDanger')
            })
        },

        // 弃用
        getIpv6SupportProductType() {
            //获取支持IPV6的机型ProductTypeId的数据
            return this.$store.dispatch(step3Const.getIpv6SupportProductType, {
                params: {
                    Region: this.regionKey,
                }
            }).then((res) => {
                if (res && res.data) {
                    this.ipv6TypeCodes = res.data;
                }
            }).catch(e => {
                commonAlert.send(e, 'kecDanger')
            })
        },
        //已用IP接口
        _fetchAdrList: _.debounce(function () {
            var subnetObj = this.subnetObj || '';
            this.ipObj = {};
            this.serverIp = '';
            let _parent = this.$parent;
            const type = _.get(_parent, 'step1Data.kecType', '') || _.get(_parent, 'kvmData.productType', '');
            if (subnetObj.ProvidedIpv6CidrBlock && this.isSupportIPV6Code(type)) {
                this.isSupportIPV6 = true;
            } else {
                this.IsDistributeIpv6 = false
                this.isSupportIPV6 = false;
            }

            if (!subnetObj.SubnetId) return;

            this.fetchAdrListLoading = true;

            if (this.kecCount == 1) {
                //查询网络预留IP
                let DescribePrivateIpAddressAttributes = this.$store.dispatch(step3Const.DescribePrivateIpAddressAttributes, {
                    params: {
                        'Region': this.regionKey,
                        AvailabilityZone: this.azCode,
                        Status: 'retain',
                        SubnetId: subnetObj.SubnetId
                    },
                    // data: {
                    //     'Filter.1.Name': 'status',
                    //     'Filter.1.Value.1': 'retain',
                    //     'Filter.2.Name': 'subnet-id',
                    //     'Filter.2.Value.1': subnetObj.SubnetId
                    // },
                    // option: {
                    //     isForm: true
                    // }
                });

                //查询已占用IP
                let AllocatedAdrList = this.$store.dispatch(step3Const.AllocatedAdrList, {
                    subnetId: subnetObj.SubnetId,
                    Region: this.regionKey,
                });

                return Promise.all([AllocatedAdrList, DescribePrivateIpAddressAttributes]).then(([data, __data]) => {
                    this.fetchAdrListLoading = false
                    if (data.code !== undefined && data.code != 200) {
                        Message.error(data.msg);
                        return;
                    }
                    var ipList = this.NotAvailableIpAddress || [];
                    var privateIp = [];
                    if (__data && __data.PrivateIpAddressAttributeSet.length) {
                        privateIp = _.map(__data.PrivateIpAddressAttributeSet, 'PrivateIpAddress');
                    }
                    ipList = ipList.concat(privateIp);
                    this.ipListLength = 1;
                    this.ipList = ipList;
                    this.dhcpFrom = subnetObj.DhcpIpFrom
                    this.dhcpTo = subnetObj.DhcpIpTo
                }, (e) => {
                    this.fetchAdrListLoading = false
                    Message.error(e.msg || e);
                });
            } else if (this.kecCount > 1) {
                //创建多台时自动分配服务器ip， 读取adrCount判断是否可用ip大于所创建主机数量
                return this.$store.dispatch(step3Const.AdrCount, {
                    subnetId: subnetObj.SubnetId,
                    Region: this.regionKey,
                }).then((data) => {
                    this.fetchAdrListLoading = false;
                    this.ipListLength = _.get(data, 'count', 0);
                    console.log('this.ipListLength::',this.ipListLength)
                }, (e) => {
                    this.fetchAdrListLoading = false;
                    Message.error(e.msg || e);
                });
            } else {
                this.fetchAdrListLoading = false
                this.ipList = [];
            }

        }, 100),
        // //描述子网
        // _fetchSubnetsList() {
        //     var self = this;
        //     var subnetObj = self.subnetObj;
        //     return this.$store.dispatch(step3Const.DescribeSubnets, {
        //         subnetId: subnetObj.SubnetId,
        //         Region: self.regionKey,
        //         // azCode:
        //     }).then((data) => {
        //         //所有的ip地址
        //         // console.log(data)
        //         // self.serverIp = '';
        //         self.dhcpFrom = self.SubnetSet[0].DhcpIpFrom
        //         self.dhcpTo = self.SubnetSet[0].DhcpIpTo
        //     });
        // },
        //关联安全组
        _filterSecurityGroup: function () {
            const res =  this.getSecurityGroupList(this.vpcObj);
            this.securityGroupList = res
            this.$refs.securitygroup.filterString = ''

            const sgList = _.filter(res, item => {
                return _.includes(this.securityValue, item.value)
            })

            if (!sgList?.length) {
                let secList = _.filter(res, item => item.UserTag === 'console');
                if ((this.DsourcePage == 'modifyTemplate' || this.DsourcePage == 'buyTemplate') && Object.keys(this.DstartTempData).length) {
                    //通过VpcId查找VPC列表是否有对应的选项
                    if (!res) {
                        this.securityGroupObj = [];
                    }
                    const DSecurityGroupId= _.get(this.DstartTempData, 'securityGroupInfo.SecurityGroupId')
                    
                    if(DSecurityGroupId){
                        this.securityGroupObj = _.filter(res, (subItem) => {
                            return subItem.SecurityGroupId == DSecurityGroupId;
                        }) || []
                    } else {
                        const securityGroupInfos = _.get(this.DstartTempData, 'securityGroupInfos',[])
                        this.securityGroupObj = _.filter(securityGroupInfos, (subItem) => {
                            if(_.find(res,item => {
                                return item.SecurityGroupId == subItem.SecurityGroupId
                            })) {
                                return subItem.securityGroupInfo
                            }
                        }) || []
                    }
                    if (!Object.keys(this.securityGroupObj).length) {
                        // Message.error('所选安全组(防火墙)已被删除，请重新选择！');
                        this.securityGroupObj = secList.length > 0 ? [secList[0]] : [];
                    }

                    // this.securityValue = this.DstartTempData.securityGroupInfo.SecurityGroupId
                    this.securityValue = _.map(this.securityGroupObj,item => {
                        return item.SecurityGroupId
                    })


                } else if (this.DsourcePage == 'createTheSameConfig' && Object.keys(this.DtheSameConfigData).length) {
                    //通过VpcId查找VPC列表是否有对应的选项
                    if (!res) {
                        this.securityGroupObj = [];
                    }
                    let networkInfo = _.find(this.DtheSameConfigData.networkInfo, (item) => {
                        return item.NetworkInterfaceType == "primary";
                    });

                    this.securityGroupObj = _.filter(networkInfo.SecurityGroupSet,item => {
                        return _.find(res, (subItem) => {
                            return subItem.SecurityGroupId == item.SecurityGroupId;
                        })
                    })

                    if (!Object.keys(this.securityGroupObj).length) {
                        // Message.error('所选安全组(防火墙)已被删除，请重新选择！');
                        this.securityGroupObj = secList.length > 0 ? [secList[0]] : [];
                    }
                    this.securityValue = _.map(this.securityGroupObj,item => {
                        return item.SecurityGroupId
                    })
                } else {
                    this.securityGroupObj = secList.length > 0 ? [secList[0]] : [];
                }
            } else {
                this.securityValue = _.map(sgList, item => item.value)
                this.securityGroupObj = sgList;
            }

            
        },
        createVpcResult() {
            this.isCreateVpc = true;
        },

        dataBind() {
            var data = {
                vpcObj: this.vpcObj,
                subnetObj: this.subnetObj,
                serverIp: this.serverIp,
                securityGroupObj: this.securityGroupObj,
                fixIpMode: this.fixIpMode,
                IsDistributeIpv6:this.IsDistributeIpv6,
                secNicList: this.secNicList,
                ipListLength: this.ipListLength
            }
            this.$emit('input', data)
        },
        $step3dataValid(silent) {
            var self = this;
            // if(this.kecCount == 1 && this.fixIpMode == 'manual' && this.ipMsg){
            if (this.kecCount == 1 && (this.fixIpMode == 'manual' || this.fixIpMode == 'auto') && this.ipMsg) {
                // if (this.kecCount == 1 && (this.fixIpMode == 'manual') && this.ipMsg) {

                Message.error(this.$trans(`请选择`) + this.$trans(`服务器IP`));
                return false;
                // return commonAlert.send(this.$trans(`请选择`) + this.$trans(`服务器IP`), 'kecDanger');
            }

            if (this.subnetObj.disabled) {
                Message.error(this.subnetObj.tipInfo);
                return false;
            }

            if (_.isEmpty(self.subnetObj) && self.subnetObj.SubnetId != '') {
                Message.error(this.$trans(`关联子网不能为空，请先创建`));
                return false;
                // return commonAlert.send(this.$trans(`关联子网不能为空，请先创建`), 'kecDanger'); //关联子网不能为空，请先创建
            }

            if (!this.subnetObj.SubnetId ? true : this.ipListLength <= 0 ) {
                Message.error(this.$trans(`当前子网下可用云服务器IP为0`));
                return false;
            }

            if (this.ipListLength < this.kecCount) {
                Message.error(this.$trans(`子网可用IP不足${this.subnetObj.SubnetId}`));
                return false;
            }

            if (_.isEmpty(self.vpcObj) && self.vpcObj.VpcId != '') {
                Message.error(this.$trans(`关联VPC不能为空，请先创建`));
                return false;
                // return commonAlert.send(this.$trans(`关联VPC不能为空，请先创建`), 'kecDanger'); //关联子网不能为空，请先创建
            }
            if ((_.isEmpty(self.securityGroupObj) && self.securityGroupId != '') || _.isEmpty(self.securityValue)) {
                Message.error(this.$trans(`关联安全组（防火墙）不能为空`));
                return false;
                // return commonAlert.send(this.$trans(`关联安全组（防火墙）不能为空`), 'kecDanger'); //关联安全组(防火墙)不能为空
            }
            if(this.securityValue?.length > this.GroupsQuotaMaxData){
                Message.error(this.$trans(`主网卡安全组数量已达到上限`))
                return false;
            }
             
            if (this.secNicList && this.secNicList.length) {
                let _subnetId = _.get(this.subnetObj, 'SubnetId', '');

                // subnetIdObj 保存主网卡和辅网卡所有的子网
                let subnetIdObjs = {
                    [_subnetId]:{
                        count: 1,
                        ipListLength: this.ipListLength
                    }
                }
                let subnetIdArr = _.map(this.secNicList, 'subnetObj.SubnetId');
                let securityValueArr = _.filter(this.secNicList, (item) =>{
                    const securityGroupObj = _.get(item,'securityGroupObj',[])
                    if(securityGroupObj.length){
                        return item
                    }
                });

                for(let i = 0; i < securityValueArr.length; i++){
                    if(securityValueArr[i].securityValue?.length > this.GroupsQuotaMaxData){
                        Message.error(this.$trans(`第{0}个辅网卡安全组数量已达到上限`, i+1))
                        return false;
                    }
                }

                subnetIdArr.push(_subnetId);
                subnetIdArr = _.compact(subnetIdArr);

                if (securityValueArr.length != this.secNicList.length) {
                    Message.error(this.$trans(`关联安全组（防火墙）不能为空`));
                    return false;
                }
                if (subnetIdArr.length != this.secNicList.length + 1) { //需要加上一个主网卡数量
                    Message.error(this.$trans(`关联VPC不能为空，请先创建`));
                    return false;
                    // 关联子网不能为空，请先创建
                }
                // if (_.uniq(subnetIdArr).length !== subnetIdArr.length) {
                //     Message.error(this.$trans(`您所选择的关联子网存在重复关联，请重新选择`));
                //     return false;
                //     //您所选择的关联子网存在重复关联，请重新选择
                // }

                // 组合主辅网卡里面的VPC和ip进行排重
                let serverIpArr = _.map(this.secNicList, (item) => {
                    if (item.vpcValue && item.serverIp) {
                        return {
                            VpcId: item.vpcValue,
                            serverIp: item.serverIp
                        }
                    }
                });
                serverIpArr.push({
                    VpcId: this.vpcObj.VpcId,
                    serverIp: this.serverIp
                });

                let uniqServerIpAndVpcId = _.uniqWith(serverIpArr, _.isEqual); //同一个VPC下不能有相同的serverIp 

                if (uniqServerIpAndVpcId.length != serverIpArr.length) {
                    Message.error(this.$trans(`您所指定的IP地址存在重复，请重新选择`));
                    return false;
                    //您所指定的IP地址存在重复，请重新选择
                }

                for(let i = 0; i < this.secNicList.length; i++){
                    const item = this.secNicList[i]
                    if (item.ipListLength < this.kecCount) {
                        Message.error(this.$trans(`子网可用IP不足({0})`, _.get(item, 'subnetObj.SubnetId')))
                        return false
                    }
                    if (this.kecCount == 1 && (item.fixIpMode == 'manual' || item.fixIpMode == 'auto') && item.ipMsg) {
                        Message.error(this.$trans(`请选择`) + this.$trans(`服务器IP`));
                        return false;
                    }
                    
                    if(subnetIdObjs[item.subnetObj.SubnetId]){
                        subnetIdObjs[item.subnetObj.SubnetId].count++
                        subnetIdObjs[item.subnetObj.SubnetId].ipListLength = item.ipListLength
                    } else {
                        subnetIdObjs[item.subnetObj.SubnetId] = {
                            count: 1, 
                            ipListLength: item.ipListLength
                        }
                    }
                }

                // 这里是主网卡 + 辅网卡的所有子网数据，如果加一起IP数量不足也报错提示
                for(let key in subnetIdObjs){
                    if(subnetIdObjs[key].count * this.kecCount > subnetIdObjs[key].ipListLength){
                        Message.error(this.$trans(`子网可用IP不足({0})`, key))
                        return false 
                    }
                    
                }

            }

            this.dataBind()
            return true;
        },
        ipCheck() {
            //只判断kecCount为1的情况
            if (this.fetchAdrListLoading) {
                return;
            }
            this.$nextTick(() => {
                if (this.kecCount == 1) {
                    if (this.serverIp == '0.0.0.0' || _.some(this.serverIp.split('.'), (item) => {
                        return (item + '') === ""
                    })) {
                        this.ipMsg = this.$trans(`目前IP还有0个，请更改VPC或者子网`); //目前IP还有0个，请更改VPC或者子网
                        return false;
                    }

                    if (!this.legalIp) {
                        if (this.ipCount) {
                            this.ipMsg = this.$trans(`已被分配`);
                        } else {
                            this.ipMsg = this.$trans(`目前IP还有0个，请更改VPC或者子网`); //目前IP还有0个，请更改VPC或者子网
                            this.serverIp = "0.0.0.0"
                        }
                        return false;
                    } else if (this.serverIp && _.some(this.serverIp.split('.'), (item) => {
                        return (item + '') === ""
                    })) {
                        this.ipMsg = this.$trans(`必须填写`); //必须填写
                        return false;
                    } else {
                        this.ipMsg = '';
                    }
                }
                this.ipMsg = '';
                return true;
            })

        },
        secnicIpCheck() {
            //只判断kecCount为1的情况
            if (this.fetchAdrListLoading) {
                return;
            }
            this.$nextTick(() => {
                _.forEach(this.secNicList, (p, idx) => {
                    if (this.kecCount == 1 && (p.fixIpMode == 'manual' || p.fixIpMode == 'auto')) {
                        if (p.serverIp == '0.0.0.0') {
                            p.ipMsg = this.$trans(`目前IP还有0个，请更改VPC或者子网`); //目前IP还有0个，请更改VPC或者子网
                            return false;
                        }
                    }
                    
                    p.ipMsg = '';
                    return true;
                });

            })

        },
        _canotUseNowIp(v) {
            this.legalIp = v;

        },
        _ipCount(v) {
            this.ipCount = v;
        },
        _secNicCanotUseNowIp(v) {
            this.legalIp = v;

        },
        _secNicIpCount(v) {
            this.ipCount = v;
        },
    },
    watch: {
        isRefresh: {
            deep: true,
            async handler(val){
                if(!val.azCode && !val.azCodeList.length) return
                await Promise.all([this.ValidateIpv6Support(), this.getVpcData()])
                if(this.secNicList?.length){
                    this.secnicIpCheck();
                    this.updataSecNicList(this.secNicList, true);
                }
                this.dataBind();
            }
            
        },
        PackageCode(val){
            if(!val) return
            Promise.all([this.ValidateIpv6Support(), this.getVpcData()])
        },
        vpcValue(val,oldVal){
            if((this.startTemplateId && val) || (val && oldVal !== '')){
                this.vpcObj = _.filter(this.vpcList,(item) => {
                    return item.value === val;
                })[0]
            }
        },
        kecCount(val) {            
            if(val > 1 && this.markCount === 0){
                this.markCount++
            }
            this._fetchAdrList()
            this.dataBind();
        },
        subnetValue(val){
            if(val){
                this.subnetObj = _.filter(this.subnetList,(item) => {
                    return item.value === val;
                })[0] || {}
            }
        },
        securityValue(val){
            if(val && val.length){
                this.securityGroupObj = _.filter(this.securityGroupList,(item) => {
                    // return item.value === val
                    return val.indexOf(item.value) !== -1
                })
            }
        },
        vpcObj(val) {
            // if(!this.vpcValue){
            //     this.vpcValue = val.value
            // }
            this.vpcValue = val.value

            this._filterSubNet();
            this._filterSecurityGroup();
            this.dataBind()
        },
        subnetObj(val) {
            this.subnetValue = val ?  val.value : ''
            //兼容随机可用区 主网卡随意切换可用区子网，辅网卡子网跟着切换
            this.showNoSubnetTip = false
            let secNicList = _.cloneDeep(this.secNicList)
            if(!this.azCode && secNicList && secNicList.length){
                secNicList.forEach((list,idx) => {
                    let _subnetList = this.getsubnetList(list.vpcObj,true)

                    var _securityGroupList = this.getSecurityGroupList(list.vpcObj)
                    let secList = _.filter(_securityGroupList, item => item.UserTag === 'console');
    
                    list.subnetList = _subnetList;

                    list.subnetObj = _subnetList.length ? _subnetList[0] : {};
                    list.subnetValue = _subnetList.length ? _subnetList[0].value : '';
                    list.securityValue = secList.length ? [secList[0].value] : [];
                    list.securityGroupObj = secList.length ? [secList[0]] : [];
                    list.securityGroupList = _securityGroupList.length ? _securityGroupList : [];
                    list.sgKeywords = ''
                    // list.filterSGList = list.securityGroupList.map()
                    this.fetchSecNicIpList('add', secNicList,idx);
                })
            }
            this._fetchAdrList();
            this.dataBind();
        },
        ipListLength(){
            this.dataBind();
        },
        fixIpMode() {
            if (this.fixIpMode == 'manual') {
                this._fetchAdrList();
            }
            this.dataBind();
        },
        serverIp() {
            this.dataBind();
            this.ipCheck();
        },
        securityGroupObj(val) {
            // this.securityValue = val ? val.value : ''
            if(!_.every(val,item => {
                item = item ? item : {}
                return this.securityValue.indexOf(item.value) !== -1
                
            })){
                this.securityValue = _.map(val,item => {
                    item = item ? item : {}
                    return item.value
                })
            }
            this.dataBind()
        },
        IsDistributeIpv6(val){
            this.dataBind()
        },
        secNicList: {
            deep: true,
            handler(val) {
                this.secnicIpCheck();
                this.updataSecNicList(val);
                this.dataBind();
            }
        }

    }

};
